export const initialDataState = {
  data: '',
  // syncedLevel: '',
  loading: '',
  fetching: false,
  error: null,
};
